import { getBetPosition } from '../../../services/auction/getBetPosition';
import { getBetPositionParams } from './utils';
import { selectCurrentBet, selectIsAuctionEnabled } from '../../../selectors/auction';
import { selectBetPositionClientError } from '../../../selectors/betPosition';
import { selectGeoChildLocation, selectOfferCoordinatesWithFallback } from '../../../selectors/offer';
import { selectIsPromotionPackageSelected, selectServiceIds } from '../../../selectors/publishTerms';
import { IAppState } from '../../../../AppModulesWrapper';
import { loadBetPositionFail, loadBetPositionStart, loadBetPositionSuccess } from '../../../actions/betPosition';
import { TThunkAction } from '../../../../common/types/thunk';
import { selectDynamicPricingData } from '../../../selectors/dynamicPricing';
import { selectPackages } from '../../../reducers/v2/publicationPackages/selectors';

export function loadBetPosition(isInstant: boolean = false): TThunkAction<Promise<void>> {
  return async function (dispatch, getState, { httpApi, logger }) {
    const state: IAppState = getState();

    logger.debug('loadBetPosition', { offer: JSON.stringify(state.servicePickerWidget.offer) });

    const serviceIds = selectServiceIds(state);
    const clientError = selectBetPositionClientError(state);
    const childLocation = selectGeoChildLocation(state);
    const coordinates = selectOfferCoordinatesWithFallback(state);
    const packages = selectPackages(state);
    const currentBet = selectCurrentBet(state);
    const isAuctionEnabled = selectIsAuctionEnabled(state);
    const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
    const extraData = selectDynamicPricingData(state);

    if (clientError) {
      return Promise.resolve();
    }

    const { offer } = state.servicePickerWidget;

    const parameters = getBetPositionParams({
      packages,
      offer,
      serviceIds,
      childLocation,
      coordinates,
      currentBet,
      isAuctionEnabled,
      isPromotionPackageSelected,
      extraData,
    });

    dispatch(loadBetPositionStart());

    const response = await getBetPosition({ httpApi, logger, parameters });

    return new Promise(resolve => {
      const delay = isInstant ? 0 : 1000;

      setTimeout(() => {
        if (response.success) {
          dispatch(loadBetPositionSuccess(response.payload));
        } else {
          dispatch(loadBetPositionFail());
        }

        return resolve();
        // При быстром ответе сервера лоадер появляется на долю секунд в компоненте позиции, из-за чего происходит мерцание.
        // Для хорошего UX ограничиваем минимально возможное выполнение запроса
      }, delay);
    });
  };
}
